export default __webpack_public_path__ + "static/media/mix.b5259689.svg";